module.exports = __webpack_public_path__ + "static/media/data-empty.41bd42a9.svg";